// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_REGISTER */
/* CRIO_SOLUTION_END_MODULE_REGISTER */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    height: 5vh;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    background: #ffffff;
}

.username-text {
    display: none;
}

.header-title {
    cursor: pointer;
}

.explore-button {
    color: #00a278 !important;
}

@media screen and (min-width: 768px) {
    .username-text {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,sCAAsC;AACtC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_REGISTER */\n/* CRIO_SOLUTION_END_MODULE_REGISTER */\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    height: 5vh;\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);\n    background: #ffffff;\n}\n\n.username-text {\n    display: none;\n}\n\n.header-title {\n    cursor: pointer;\n}\n\n.explore-button {\n    color: #00a278 !important;\n}\n\n@media screen and (min-width: 768px) {\n    .username-text {\n        display: block;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
